import { env } from '@/src/config/env'

export type TPicture = {
  id: number
  slug?: string | null
  ext?: 'jpg' | 'png' | 'svg' | 'webp' | 'gif'
  aspectRatio?: `${number}:${number}` | null
}

export type TImageSrc = TPicture | string | null

export function getImageUrl(image?: TImageSrc, size: string | null = null): string {
  if (!image || typeof image === 'string') {
    return image || ''
  }
  const result = [env.EXPO_PUBLIC_FILES_URL, '/', image.id, image.slug && `-${image.slug}`, size && `!${size}`, '.webp']
    .filter(Boolean)
    .join('')

  return result
}
